import { Box, Typography, MenuItem, FormControl, Select, InputLabel } from '@mui/material';
import IF from '../../ui/IF';
import { useTranslation } from 'react-i18next';

const SearchResultHeader = ({ onSortChange, showFormControl, sortOptions, sortBy, sortDirection, selectedSortOption, title, headerActionComponent, actionComponent, showTitle = false, sx }) => {
  const { t } = useTranslation();

  const directionData = [
    {
      label: t('Label_Ascending'),
      value: 'asc'
    },
    {
      label: t('Label_Descending'),
      value: 'desc'
    }
  ];

  return (

    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        mb: 2,
        mt: -1,
        ...sx
      }}
    >
      <Box sx={{ alignItems: 'center', display: 'flex' }}>
        <IF condition={showTitle}>
          <Typography
            color="textPrimary" variant="h6"
          >
            {title}
          </Typography>
        </IF>
        <IF condition={showFormControl}>
          { sortOptions && onSortChange && (
            <FormControl size="small" sx={{ width: '130px', ml: 2 }}>
              <InputLabel id="sort-by">{t('Label_SortBy')}</InputLabel>
              <Select
                labelId="sort-by"
                id="sort-by"
                value={selectedSortOption}
                label="Sort By"
                onChange={(event) => onSortChange({ sortBy: event.target?.value, sortOrder: sortDirection })}
              >
                {sortOptions.map((option) => (
                  <MenuItem key={option?.value} value={option?.value}>
                    {t(option?.label)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <FormControl size="small" sx={{ width: '130px', marginLeft: '8px' }}>
            <InputLabel>{t('Label_Direction')}</InputLabel>
            <Select
              value={sortDirection || sortDirection?.Asc}
              label="Direction"
              onChange={(event) => onSortChange({ sortBy, sortOrder: event.target?.value })}
            >
              {directionData.map((option) => (
                <MenuItem key={option?.value} value={option?.value}>
                  {t(option?.label)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </IF>
        {headerActionComponent}
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        {actionComponent}
      </Box>
    </Box>
  );
};
export default SearchResultHeader;
